"use client";
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";

export default function RootLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {

  return (
    <>
      <Header />
      <main className="content">{children}</main>
      <Footer />
    </>
  );
}
